export default {"src":"/_next/static/media/any_vet.e59b710b.svg","height":86,"width":104};